import Column from "./default"
import {
	addCopyAndPasteEventToElement
} from "./utils"

export default class SelectColumn extends Column {
	selectOptions = []
	valueMap = {}

	/**
	 * @type {(any, Array) => []}
	 */
	visibleOptionRule = (data, options) => {
		return options.map(opt => opt.value)
	}

	#icon

	#dangerouslyCachedNotifyCellEditEnd

	constructor ({ options }) {
		super({ options })
		this.selectOptions = options.options || []
		this.selectOptions.forEach(option => {
			this.valueMap[option.value] = option.label
		})
		if (options.visibleOptionRule) this.visibleOptionRule = options.visibleOptionRule

		const icon = document.createElement("bui-icon")
		icon.icon = "fas fa-angle-down"
		icon.style.top = "0px"
		icon.style.right = "0px"
		icon.style.bottom = "0px"
		icon.style.cursor = "pointer"
		icon.style.position = "absolute"
		this.#icon = icon
	}

	onCellEdit (ctx, setValue, notifyCellEditEnd) {
		if (this.options.unmodifiableRule(ctx.currentCellInfo.row.data)) {
			return
		}
		const clickTarget = document.createElement("div")
		clickTarget.setAttribute("tabindex", 0)
		clickTarget.style.position = "absolute"
		clickTarget.style.top = "0px"
		clickTarget.style.left = "0px"
		clickTarget.style.bottom = "0px"
		clickTarget.style.right = "0px"
		clickTarget.style.outline = "none"
		clickTarget.addEventListener("click", e => {
			e.stopPropagation()
			this.createMenu(ctx, setValue, notifyCellEditEnd)
		})

		clickTarget.addEventListener("keydown", e => {
			if (e.key === "Enter") {
				e.preventDefault()
				const menu = ctx.inputEl.querySelector("bui-menu")
				if (!menu) {
					this.createMenu(ctx, setValue, notifyCellEditEnd)
				} else {
					menu.hide()
				}
			} else if (Column.INPUT_END_KEYS.includes(e.key)) {
				// const menu = ctx.inputEl.querySelector("bui-menu")
				// if (!menu) {
				// 	clickTarget.blur()
				// } else {
				// 	menu.hide()
				// }
			} else if (e.key === "Backspace") {
				setValue(null)
			}
		})

		addCopyAndPasteEventToElement(clickTarget)

		this.requestFocus = true
		clickTarget.addEventListener("blur", e => {
			const menu = ctx.inputEl.querySelector("bui-menu")
			if (!menu) {
				// ここでフォーカスすると、２つ以上グリッドがあった場合にフォーカスの奪い合いになり動作しなくなる
				this.requestFocus = false
				this.onCellEditEnd(ctx)
			}
		})

		clickTarget.appendChild(this.#icon)

		ctx.inputEl.appendChild(clickTarget)
		setTimeout(() => {
			clickTarget.focus()
		})
	}

	createMenu (ctx, setValue, notifyCellEditEnd) {
		const visibleValues = this.visibleOptionRule(ctx.currentCellInfo.row.data, this.selectOptions)
		const menu = document.createElement("bui-menu")
		const onClick = value => {
			return (e) => {
				setValue(value)
				notifyCellEditEnd()
			}
		}
		menu.init([
			{ items: this.selectOptions.filter(opt => visibleValues.includes(opt.value)).map(option => { return { text: option.label, onClick: onClick(option.value) } }) }
		])
		// 選択時に自動でクローズされるため、親のonCellEditEndのみ呼び出す
		menu.addEventListener("popup-close", () => {
			super.onCellEditEnd(ctx, this.requestFocus)
		})

		const inputWrapper = ctx.inputEl
		inputWrapper.appendChild(menu)
		menu.updateComplete.then(() => {
			menu.showAtTarget({ target: inputWrapper })
		})

		menu.addEventListener("modal-aftershow", e => e.stopPropagation())
	}

	onCellEditEnd (ctx) {
		const { inputEl } = ctx
		// hideを実行すればpopup-closeイベントが発火され、リスナからonCellEditEndが呼び出される
		const menu = inputEl.querySelector("bui-menu")
		if (menu) {
			menu.hide()
		} else {
			super.onCellEditEnd(ctx, this.requestFocus)
		}
	}

	renderCell (ctx, props) {
		props.value = this.valueMap[props.value]
		this.renderCellDefault(ctx, props)
	}
}
